import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeImg extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
